import { all, put, takeLatest, call } from 'redux-saga/effects';
import { ISA_ERROR } from '../../constants';
import notification from '../../services/notification';
import history from '../../services/history';
import normalizeError from '../../utils/normalize-error';
import * as AuthActions from './auth/auth-actions';

import auth from './auth/auth-sagas';
import user from './user/user-sagas';
import team from './team/team-sagas';
import rewards from './rewards/rewards-sagas';
import sponsored from './sponsored/sponsored-sagas';
import trading from './trading/trading-sagas';
import order from './order/order-sagas';
import orderCreate from './order/order-create-sagas';
import configuration from './configuration/configuration-sagas';
import tenant from './tenant/tenant-sagas';
import promotion from './promotion/promotion-sagas';
// import acccesProfile from './access-profile/access-profile-sagas';
import loadType from './load-type/load-type-sagas';
import loadControl from './load-control/load-control-sagas';
import client from './client/client-sagas';
import reason from './reason/reason-sagas';
import product from './product/product-sagas';
import productList from './product-list/product-list-sagas';
import orderType from './order-type/order-type-sagas';
import notifications from './notifications/notifications-sagas';
import productKit from './product-kit/product-kit-sagas';
import orderSplit from './order-split/order-split-sagas';
import ratings from './ratings/ratings-sagas';
import salesTracking from './sales-tracking/sales-tracking-sagas';
import clientVisit from './client-visit/client-visit-sagas';
import productPhotos from './product-photos/product-photos-sagas';
import controlNotifications from './control-notifications/control-notifications-sagas';
import clientChecklist from './client-checklist/client-checklist-sagas';
import clientReportsChecklist from './client-report-checklist/client-report-checklist-sagas';
import justifications from './justifications/justifications-sagas';
import promotionKitReport from './promotion-kit-report/promotion-kit-report-sagas';
import auditUser from './audit-user/audit-user-sagas';
import bonificationProduct from './bonification-product/bonification-product-sagas';
import focusSupplier from './focus-supplier/focus-supplier-sagas';
import dailyRoute from './daily-route/daily-route-sagas';
import dailyRouteReport from './daily-route-report/daily-route-report-sagas';
import vendorClientVisitReport from './vendor-client-visit/vendor-client-visit-sagas';
import productTechnical from './product-technical/product-technical-sagas';
import selectPagination from './select-pagination/select-pagination-saga';
import commissionReport from './commission-report/commission-report-sagas';
import clientPositionReport from './client-position-report/client-position-report-sagas';
import routing from './routing/routing-sagas';
import routedClientsReport from './routed-clients-report/routed-clients-report-sagas';
import productWithoutPictureReport from './product-without-picture-report/product-without-picture-report-sagas';
import mandatoryMix from './mandatory-mix/mandatory-mix-sagas';

const parseErrorMessage = err => {
  switch (err) {
    case 'JWT expired or not received':
      return 'Login expirado';
    case 'Unable to login: wrong password':
      return 'Senha inválida';
    case 'Unable to login: email not found':
      return 'Email não encontrado';
    case 'Fields validation failed':
      return 'Email inválido';
    case 'Not a valid active user':
      return 'Usuário não encontrado, procurar o T.I';
    case 'User is not activated':
      return 'O usuário não está ativado.\nVerifique com o TI da sua empresa e tente novamente!';
    case 'User already registered with another device, new entry need to be activated by admin':
      return 'Usuário já registrado em outro dispositivo.\nVerifique com o TI da sua empresa e tente novamente!';
    case 'Verifique seus dados e tente novamente':
      return 'Verifique seus dados e tente novamente';
    default:
      return 'Verifique a conexão com sua internet';
  }
};

export function* erroHandler({ error }: any) {
  const message = normalizeError(error);

  if (error?.response?.status === 401) {
    const messageUnauthorized = parseErrorMessage(error?.response?.data?.message);
    if (error?.response?.data?.message === 'JWT expired or not received') {
      yield put(AuthActions.logoutRequest());

      yield call(history.push, '/auth/login');

      yield call(notification.warning, messageUnauthorized);
    } else {
      yield call(notification.warning, messageUnauthorized);
    }
  } else {
    yield call(notification.error, message);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ISA_ERROR, erroHandler),
    auth,
    user,
    team,
    rewards,
    sponsored,
    trading,
    order,
    orderType,
    orderCreate,
    configuration,
    tenant,
    promotion,
    // acccesProfile,
    loadType,
    loadControl,
    client,
    reason,
    product,
    productList,
    notifications,
    productKit,
    orderSplit,
    ratings,
    salesTracking,
    clientVisit,
    productPhotos,
    controlNotifications,
    clientChecklist,
    clientReportsChecklist,
    justifications,
    promotionKitReport,
    auditUser,
    bonificationProduct,
    focusSupplier,
    dailyRoute,
    dailyRouteReport,
    productTechnical,
    selectPagination,
    vendorClientVisitReport,
    commissionReport,
    clientPositionReport,
    routing,
    routedClientsReport,
    productWithoutPictureReport,
    mandatoryMix
  ]);
}
